import "./Nav.css"
import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { filter, first, length, map } from "@pdfking/rfunc"
import { RecordMerge } from "@pdfking/tfunc"
import { Icon } from "@pdfking/workflow/components/Icon"
import fire_event from "@pdfking/workflow/utils/fire_event"
import make_translations from "@pdfking/workflow/utils/make_translations"
import proxy from "@pdfking/workflow/utils/proxy"
import autocomplete from "../../constants/autocomplete"
import breadcrumbs from "../../constants/breadcrumbs"
import selector from "../../dom/selector"
import { CloseMixin } from "../../mixins/Close"
import { FreezeMixin } from "../../mixins/Freeze"
import cx from "../../utils/cx"
import navigate from "../navigate"
import { NAV_VIEW } from "../urls"
import { Filters } from "./layout/Filters"
import { Results } from "./layout/Results"

export const Nav = CreateRenderFunction({
  computed: {
    ...proxy(autocomplete(), [
      "pages_index",
      "pages_descendants_by_url",
      "pages_by_url",
    ] as const),
    html_content() {
      return map(
        (e: HTMLElement) => e.innerHTML,
        selector(this.html_selector)
      ).join("")
    },
    is_main() {
      return !this.url
    },
    main_descendants() {
      if (this.url && this.pages_by_url && this.pages_by_url[this.url]) {
        let array = this.descendants(this.url)
        if (array && this.limit) {
          array = array.slice(0, this.limit)
        }
        return map(
          (o: any) =>
            RecordMerge(o, {
              descendants: this.descendants(o.url),
            }),
          array
        )
      }
    },
    megamenu_content() {
      return map(
        (e: HTMLElement) => ({
          title: e.innerHTML,
          url: e.getAttribute("href"),
        }),
        filter(
          (e: HTMLElement) => e.innerHTML,
          selector(this.megamenu_selector)
        )
      )
    },
    megamenu_filters() {
      return map(
        (el: any) => ({ id: el.url, title: el.title }),
        this.megamenu_content
      )
    },
    translations: () => make_translations("actions"),
  },
  data: {
    html_selector: ".main-offcanvas",
    megamenu_selector: ".main-megamenu[href]:not(.menu-0y6hmbho)",
    toggled_class: "search-body",
  },
  methods: {
    descendants(url: string) {
      if (url && this.pages_descendants_by_url) {
        return filter(
          (p: any) => p.in_navigation,
          this.pages_descendants_by_url[url] || []
        )
      }
      return []
    },

    length,
    open_link(url?: string) {
      navigate(NAV_VIEW, url ? { url } : {})
    },
  },
  mixins: [CloseMixin, FreezeMixin],
  async mounted() {
    fire_event(document, "focus_search")
    if (this.url === "auto") {
      for (const url of breadcrumbs().links) {
        for (const { url: cmp } of this.megamenu_content) {
          if (url === cmp) {
            return this.open_link(url)
          }
        }
      }
      return this.open_link(first(this.megamenu_content).url)
    }
  },
  props: {
    limit: null as number | null,
    title: "" as string,
    url: "" as string,
  },
  render() {
    return (
      <div class="position-absolute bg-white z-2 w-100 main-menu overflow-hidden">
        <div class="container position-relative d-flex flex-column h-100">
          <button
            class="btn-close position-absolute top-0 end-0 mx-3 my-4 p-2 rounded-circle border bg-white d-none d-lg-block"
            onClick={this.close}
            type="button"
          />

          {!this.is_main && (
            <a
              class="d-md-none clickable h5 dropdown-item d-block mt-1"
              onClick={(e: Event) => {
                e.stopPropagation()
                e.preventDefault()
                this.open_link()
              }}
            >
              <Icon name="ARROW_LEFT" /> {this.translations.actions.SHOW_ALL}
            </a>
          )}
          <div class="row h-100">
            {!this.is_main && (
              <div class="col order-lg-last overflow-scroll overscroll-contain no-scrollbar h-100">
                {!this.main_descendants && !this.is_main ? (
                  <div class="w-100 h-100 text-center">
                    <div class="spinner-border muted m-5 p-5" />
                  </div>
                ) : (
                  this.main_descendants && (
                    <Results pages={this.main_descendants} />
                  )
                )}
              </div>
            )}
            <div class="col-12 col-lg-3 overflow-scroll overscroll-contain no-scrollbar h-100 border-end g-0 me-2">
              {this.megamenu_content && (
                <div class={cx({ "d-none d-lg-flex": this.main_descendants })}>
                  <Filters
                    action={this.open_link}
                    class="mt-4 w-100"
                    filters={this.megamenu_filters}
                    selected={this.url}
                  />
                </div>
              )}
              {this.html_content && (
                <div
                  class="w-100 d-flex flex-column d-lg-none mb-4 ms-3"
                  dangerouslySetInnerHTML={{ __html: this.html_content }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  },
})
